import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

import TabLayout from "@/layouts/TabLayout.vue";
import AuthLayout from "@/layouts/AuthLayout.vue";
import DashboardLayout from "@/layouts/DashboardLayout.vue";
import { ROLES } from '../consts';

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	linkActiveClass: 'active',
	routes: [
		{
			path: "/",
			redirect: "inicio",
			component: DashboardLayout,
			children: [
				{
					path: "pa",
					component: TabLayout,
					redirect: '/pa/experts',
					props: {
						tabs: [
							{
								name: 'Peritos',
								path: '/pa/experts'
							},
							{ divider: true },
							{
								name: 'Asignacion',
								path: '/pa/assignments'
							}
						]
					},
					children: [
						{
							path: 'experts',
							name: 'Experts',
							components: {
								form: () => import(/* webpackChunkName: "experts" */ "../views/Experts/ExpertForm.vue"),
								default: () => import(/* webpackChunkName: "experts" */ "../views/Experts/ExpertsTable.vue"),
							},
							meta: {
								requireAuth: true,
								requireRoles: [ROLES.CLIENT]
							}
						},
						{
							path: 'assignments',
							name: 'Assignments',
							components: {
								form: () => import(/* webpackChunkName: "assignments" */ "../views/Assignments/AssignmentForm.vue"),
								default: () => import(/* webpackChunkName: "assignments" */ "../views/Assignments/AssignmentsTable.vue"),
							},
							meta: {
								requireAuth: true,
								requireRoles: [ROLES.CLIENT]
							}
						}
					]
				},
				{
					path: "auc",
					component: TabLayout,
					redirect: '/auc/clients',
					props: {
						tabs: [
							{
								name: 'Clients',
								path: '/auc/clients'
							},
							{ divider: true },
							{
								name: 'Usuarios',
								path: '/auc/users'
							}
						]
					},
					children: [
						{
							path: 'clients',
							name: 'Clients',
							components: {
								form: () => import(/* webpackChunkName: "clients" */ "../views/Clients/ClientForm.vue"),
								default: () => import(/* webpackChunkName: "clients" */ "../views/Clients/ClientsTable.vue"),
							},
							meta: {
								requireAuth: true,
								requireRoles: [ROLES.ADMIN]
							}
						},
						{
							path: 'users',
							name: 'Users',
							components: {
								form: () => import(/* webpackChunkName: "assignments" */ "../views/Users/UserForm.vue"),
								default: () => import(/* webpackChunkName: "assignments" */ "../views/Users/UsersTable.vue"),
							},
							meta: {
								requireAuth: true,
								requireRoles: [ROLES.ADMIN]
							}
						}
					]
				},
				{
					path: "/dashboard",
					name: "dashboard",
					component: () => import(/* webpackChunkName: "demo" */ "../views/Dashboard.vue"),
					meta: {
						requireAuth: true
					}
				},
				{
					path: "/inicio",
					name: "EasyVal WebApp",
					component: () => import(/* webpackChunkName: "demo" */ "../views/Inicio.vue"),
					meta: {
						requireAuth: true
					}
				},
				{
					path: "/requests",
					name: "Requests",
					component: () => import(/* webpackChunkName: "requests" */ "../views/Requests.vue"),
					meta: {
						requireAuth: true,
						requireRoles: [ROLES.ADMIN]
					}
				},
				{
					path: "/assignments",
					name: "ExpertAssignments",
					component: () => import(/* webpackChunkName: "assignments" */ "../views/Assignments.vue"),
					meta: {
						requireAuth: true,
						requireRoles: [
							ROLES.ADMIN,
							ROLES.EXPERT_ADMIN,
							ROLES.EXPERT_CLIENT,
						]
					}
				},
				{
					path: "/icons",
					name: "Asignaciones",
					component: () => import(/* webpackChunkName: "demo" */ "../views/Asignaciones/Index.vue"),
					meta: {
						requireAuth: true
					}
				},
				{
					path: "/profile",
					name: "profile",
					component: () => import(/* webpackChunkName: "demo" */ "../views/Pages/UserProfile.vue"),
					meta: {
						requireAuth: true
					}
				},
				{
					path: "/refmercado",
					name: "Referencia de Mercado",
					component: () => import(/* webpackChunkName: "demo" */ "../views/RefMercado.vue"),
					meta: {
						requireAuth: true
					}
				},
				{
					path: "/heatmap",
					name: "Mapa de Calor",
					component: () => import(/* webpackChunkName: "demo" */ "../views/HeatMap.vue"),
					meta: {
						requireAuth: true
					}
				},
				{
					path: "/appraisals",
					name: "Appraisals",
					component: () => import(/* webpackChunkName: "demo" */ "../views/Appraisals.vue"),
					meta: {
						requireAuth: true,
						requireRoles: [ROLES.CLIENT]
					}
				},
				{
					path: "/tables",
					name: "Estado de Avalúos",
					component: () => import(/* webpackChunkName: "demo" */ "../views/RegularTables.vue"),
					meta: {
						requireAuth: true
					}
				}
			]
		},
		{
			path: "/",
			redirect: "login",
			component: AuthLayout,
			children: [
				{
					path: "/login",
					name: "Login",
					component: () => import(/* webpackChunkName: "login" */ "../views/auth/Login.vue"),
					meta: {
						requiresUnAuth: true
					}
				},
				{
					path: "/forgot-password",
					name: "ForgotPassword",
					component: () => import(/* webpackChunkName: "forgot-password" */ "../views/auth/ForgotPassword.vue"),
					meta: {
						requiresUnAuth: true
					}
				},
			]
		},
		{
			path: "*",
			name: '404',
			component: () => import(/* webpackChunkName: "404" */ "../views/NotFound.vue"),
		}
	],
	scrollBehavior: (to, _, savedPosition) => {
		if (savedPosition) { return savedPosition }
		if (to.hash) { return { selector: to.hash } }
		return { x: 0, y: 0 }
	}
});

const matchMeta = (to, key) => {
	return to.matched.some(
		route => route.meta[key]
	)
}

router.beforeEach((to, _, next) => {
	const isLoggedIn = store.getters['auth/$isLoggedIn']

	if (!isLoggedIn && matchMeta(to, 'requireAuth')) {
		return next('/login')
	}
	if (isLoggedIn) {
		// REDIRECT IF LOGGED IN
		if (matchMeta(to, 'requiresUnAuth')) return next('/')

		// ENSURE ROLE PERMISSION
		const requireRoles = matchMeta(to, 'requireRoles')
		const userRole = store.getters['auth/$currentUser'].role
		if (requireRoles && !to.meta.requireRoles.includes(userRole)) {
			return next('/404')
		}
	}
	return next()
})

export default router;
